import React from 'react';
import { Container, Paper, Typography, Box } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const QuizCompleted: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 8, mb: 8 }}>
      <Paper elevation={3} sx={{ p: 6, borderRadius: 2, textAlign: 'center' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <CheckCircleOutlineIcon sx={{ fontSize: 100, color: 'success.main' }} />
        </Box>

        <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
          Quiz Completed
        </Typography>

        <Typography variant="h6" color="text.secondary" paragraph>
          Thank you for completing the quiz!
        </Typography>

        <Typography variant="body1" color="text.secondary">
          Your responses have been submitted and will be reviewed shortly.
        </Typography>
      </Paper>
    </Container>
  );
};

export default QuizCompleted;
